export default "__VITE_PUBLIC_ASSET__2e5147f5__"